import React, { useRef, useEffect } from 'react';
import GanttChartHierarchicalFixed from './GanttChartHierarchicalFixed';

/**
 * A wrapper component that provides refresh functionality for the Gantt chart
 * Reverted to original working version while investigating view differences
 */
const GanttChartRefreshableFixed = (props) => {
  const { projectId } = props;
  const ganttRef = useRef(null);
  
  // Listen for global refresh events
  useEffect(() => {
    const handleGlobalRefresh = (event) => {
      if (event.detail && event.detail.projectId && event.detail.projectId === projectId) {
        console.log('GanttChartRefreshableFixed received refresh event for project', projectId);
        if (ganttRef.current) {
          ganttRef.current.refresh();
        }
      }
    };
    
    window.addEventListener('gantt:refresh', handleGlobalRefresh);
    
    return () => {
      window.removeEventListener('gantt:refresh', handleGlobalRefresh);
    };
  }, [projectId]);
  
  console.log('GanttChartRefreshableFixed rendering with original component, props:', props);
  return <GanttChartHierarchicalFixed {...props} ref={ganttRef} />;
};

export default GanttChartRefreshableFixed;